import React, { ReactNode, useMemo } from 'react';
import cx from 'clsx';

import style from './index.module.scss';

export const DrawToken = ({
  children,
  className,
  size = 20,
}: {
  children?: ReactNode;
  className?: string;
  size?: number;
}) => {
  const rectStyle = useMemo(
    () => ({ minWidth: size, height: size, lineHeight: `${size}px` }),
    [size],
  );
  const drawStyle = useMemo(() => ({ height: size, width: size * (4 / 27) }), [size]);

  return (
    <div className={cx(style.container, className)}>
      <div className={style.drawToken} style={rectStyle}>
        {children}
      </div>
      <div className={style.drawSaw} style={drawStyle} />
    </div>
  );
};
